import React from "react";
import { Dots } from "react-dot-patterns";

const HowItWorks = () => {
  return (
    <div className="automobile-working-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>
      <div className="section-title">
        <h1 className="title">How It Works</h1>
      </div>
      <div className="working-container">
        <div className="working-box">
          <div className="working-detail first">
            <div className="arrow"></div>
            <h4>Supply Chain Analysis</h4>
            <p>Understand your current workflows and bottlenecks.</p>
          </div>
        </div>
        <div className="working-box">
          <div className="working-detail second">
            <div className="arrow"></div>
            <h4>Tailored Implementation</h4>
            <p>
              Customize the solution for your specific production and supply
              chain needs.
            </p>
          </div>
        </div>
        <div className="working-box">
          <div className="working-detail third">
            <div className="arrow"></div>
            <h4>Seamless Integration</h4>
            <p>
              Integrate with your existing ERP and dealer management systems.
            </p>
          </div>
        </div>
        <div className="working-box">
          <div className="working-detail forth">
            <div className="arrow"></div>
            <h4>Ongoing Support</h4>
            <p>Provide continuous support for optimal operations.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
